import { Injectable, Inject } from '@angular/core';
import { catchError, forkJoin, map, Observable, of, ReplaySubject } from 'rxjs';
import { Environment } from '../classes/environment';
import { NewsService } from './news.service';
import { DocumentExchangeService } from './document-exchange.service';
import { ChatService } from './chat.service';


@Injectable({ providedIn: 'root' })
export class NewCountersService {


	newNews = new ReplaySubject<string>();
	private iNewNews = 0;
	newDocuments = new ReplaySubject<string>();
	private iNewDocuments = 0;
	newChats = new ReplaySubject<string>();
	private iNewChats = 0;
	private chatPollTimeoutId = 0;
	private chatPollActive = false;


	constructor(
		@Inject('environment') private environment: Environment,
		private newsService: NewsService,
		private documentExchangeService: DocumentExchangeService,
		private chatService: ChatService,
	) {}


	getNewCounters(): Observable<boolean> {

		const obss = [

			this.newsService.getNews().pipe( 

				map( news => {

					const subscribedRubrics = this.newsService.getStoredSubscribedRubrics();
					const newNews = news
						.filter( n => n.bReleased )
						.filter( n => {
							for( const r of n.rubrics ) {
								if( subscribedRubrics.includes( r ) ) return true;
							}
							return false;
						})
						.filter( n => !n.bSeen );

					this.iNewNews = newNews.length;
					this.newNews.next( this.formatNewCounter( this.iNewNews ) );

					return true;

				})
	
			)

		];

		if( this.environment.features.austausch ) {

			obss.push(
				this.documentExchangeService.getDocumentExchanges( 0, null, null ).pipe(
					map( answer => {

						if( !answer ) return false;

						this.iNewDocuments = 0;
						for( const document of answer.elements ) {
							if( !document.bSeen ) this.iNewDocuments++;
						}
						
						this.newDocuments.next( this.formatNewCounter( this.iNewDocuments ) );
						return true;

					})
				)
			);

		}

		if( this.environment.features.kommunikation ) {
			
			this.startChatPolling();
			obss.push( this.getNewChats() );

		} else {
			this.stopChatPolling();
		}


		return forkJoin( obss ).pipe(

			map( answers => {
				if( !answers ) return false;
				for( const answer of answers ) {
					if( !answer ) return false;
				}
				return true;
			}),
			catchError( err => {
				return of(false);
			})

		);

	}

	private formatNewCounter( i: number ): string {
		if( i <= 0 ) return "";
		if( i >= 20 ) return "20+";
		return "" + i;
	}

	decrementNewChats() {

		this.iNewChats = (this.iNewChats <= 1) ? 0 : this.iNewChats-1;
		this.newChats.next( this.formatNewCounter( this.iNewChats ) );

	}

	decrementNewNews() {

		this.iNewNews = (this.iNewNews <= 1) ? 0 : this.iNewNews-1;
		this.newNews.next( this.formatNewCounter( this.iNewNews ) );

	}

	decrementNewDocuments() {

		this.iNewDocuments = (this.iNewDocuments <= 1) ? 0 : this.iNewDocuments-1;
		this.newDocuments.next( this.formatNewCounter( this.iNewDocuments ) );

	}

	private getNewChats(): Observable<boolean> {

		return this.chatService.getChats().pipe(
			map( answer => {

				if( !answer ) return false;

				this.iNewChats = 0;
				for( const chat of answer.chats ) {
					if( chat.bNewMsg ) this.iNewChats++;
				}
				this.newChats.next( this.formatNewCounter( this.iNewChats ) );

				this.scheduleNextChatPoll();

				return true;

			})
		);

	}

	private startChatPolling() {
		this.chatPollActive = true;
	}

	stopChatPolling() {
		this.chatPollActive = false;
		if( this.chatPollTimeoutId ) {
			window.clearTimeout( this.chatPollTimeoutId );
			this.chatPollTimeoutId = 0;
		}
	}

	private scheduleNextChatPoll() {
		if( !this.chatPollActive ) return;
		if( this.chatPollTimeoutId ) {
			window.clearTimeout( this.chatPollTimeoutId );
		}
		this.chatPollTimeoutId = window.setTimeout( () => {
			if( !this.chatPollActive ) return;
			this.getNewChats().subscribe();
		}, 20000 );
	}


}


